// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
define([], ()=>{
    const E = {};
    return E;
});
